import { AVAILABLE_WORLDS } from '../../languages/constants';
import ReferralPromoFlagES from '../../images/referral-promo/flags/es.svg';
import ReferralPromoFlagGR from '../../images/referral-promo/flags/gr.svg';
import { world } from '../../languages';

const ReferralPromoFlags = {
    [AVAILABLE_WORLDS.ES]: ReferralPromoFlagES,
    [AVAILABLE_WORLDS.GR]: ReferralPromoFlagGR
}
const ReferralPromoFlag = () => {
    const flagUrl = ReferralPromoFlags[world] ?? ReferralPromoFlagES;

    return (
        <img src={flagUrl} alt='flag'/>
    );
};

export default ReferralPromoFlag;
